import React from 'react';
import PropTypes from 'prop-types';
import { Modal, Grid, Button, Typography, Divider, CardContent } from '@mui/material';

const SimpleModal = ({ open, closeModal, handleConfirm }) => {
    return (
        <Modal open={open} onClose={closeModal} aria-labelledby="simple-modal-title" aria-describedby="simple-modal-description">
            <Grid container justifyContent="center" alignItems="center" height="100%">
                <div style={{ backgroundColor: 'white', padding: '20px', borderRadius: '8px', maxWidth: '400px' }}>
                    {/* Modal Title */}
                    <CardContent>
                        <Typography variant="h3" id="simple-modal-title" gutterBottom>
                            Bạn muốn tải tài liệu?
                        </Typography>
                        <Divider />
                        {/* Modal Content */}
                        <Typography sx={{ mt: 2 }} id="simple-modal-description" paragraph>
                            Hệ thống sẽ mất một ít thời gian để có thể xử lý tài liệu này theo yêu cầu của bạn!
                        </Typography>
                    </CardContent>
                    {/* Action Buttons */}
                    <Grid container justifyContent="flex-end" sx={{ marginTop: 2 }}>
                        <Button variant="outlined" color="secondary" onClick={closeModal}>
                            Thoát
                        </Button>
                        <Button variant="outlined" color="primary" onClick={handleConfirm} sx={{ marginLeft: 2 }}>
                            Đồng ý
                        </Button>
                    </Grid>
                </div>
            </Grid>
        </Modal>
    );
};

SimpleModal.propTypes = {
    open: PropTypes.bool.isRequired,
    closeModal: PropTypes.func.isRequired
    // handleConfirm: PropTypes.func.isRequired,
};

export default SimpleModal;
